import script from "./LingoTooltipComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoTooltipComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LingoTooltipComponent.vue?vue&type=style&index=0&id=4a06c225&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a06c225"]])

export default __exports__